import { userConstants } from "../../constant";

export function recentlyViewed(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_RECENTLY_VIEWED_PRODUCT:
      return {
        recentlyViewed: action.products,
      };
    default:
      return state;
  }
}
